import { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import PageHeader from "@/components/feature/PageHeader";
import ArticleCard from "@/components/feature/ArticleCard";
import useSeo from "@/hooks/useSeo";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function Topics() {
  const [params, setParams] = useSearchParams();
  const active = params.get("c") || "all";
  const current = categories.find((c) => c.slug === active);

  useSeo({
    title: current
      ? `${current.name} - 18爆料网栏目合集`
      : "全部栏目 - 18爆料网娱乐爆料分类合集",
    description: current
      ? `${current.desc} 18爆料网「${current.name}」栏目持续更新，聚合相关热点与深度内容。`
      : "18爆料网全部栏目合集，涵盖明星塌房、艺人黑历史、娱乐圈内幕、恋情风云与综艺瓜田，分类浏览更高效。",
    keywords: `${current ? current.name + "," : ""}18爆料网,娱乐爆料,明星黑料,娱乐圈内幕`,
    path: "/topics",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: current ? `${current.name} - 18爆料网` : "全部栏目 - 18爆料网",
      description: current ? current.desc : "18爆料网全部栏目合集。",
      inLanguage: "zh-CN",
      hasPart: categories.map((c) => ({
        "@type": "WebPage",
        name: c.name,
        description: c.desc,
      })),
    },
  });

  const list = useMemo(() => {
    if (active === "all") return articles;
    return articles.filter((a) => a.category === active);
  }, [active]);

  return (
    <>
      <PageHeader
        title={current ? current.name : "全部栏目"}
        subtitle={
          current
            ? current.desc
            : "五大栏目分类整理，从明星塌房到圈内内幕，按你关心的话题快速找到相关内容。"
        }
        crumbs={[{ label: "首页", to: "/" }, { label: "栏目", to: "/topics" }, ...(current ? [{ label: current.name }] : [])]}
      />

      <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => setParams({})}
            className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm transition-colors cursor-pointer ${
              active === "all"
                ? "border-primary-500 bg-primary-500 font-medium text-background-50"
                : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            全部栏目
          </button>
          {categories.map((c) => (
            <button
              key={c.slug}
              type="button"
              onClick={() => setParams({ c: c.slug })}
              className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm transition-colors cursor-pointer ${
                active === c.slug
                  ? "border-primary-500 bg-primary-500 font-medium text-background-50"
                  : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {c.name}
            </button>
          ))}
        </div>

        {!current && (
          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {categories.map((c) => (
              <button
                key={c.slug}
                type="button"
                onClick={() => setParams({ c: c.slug })}
                className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 text-left transition-colors hover:border-primary-300 cursor-pointer"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700">
                  <i className={c.icon}></i>
                </span>
                <span>
                  <span className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                    {c.name}
                    <span className="text-xs font-normal text-foreground-400">{c.count} 条</span>
                  </span>
                  <span className="mt-1 block text-sm leading-6 text-foreground-600">{c.desc}</span>
                </span>
              </button>
            ))}
          </div>
        )}

        <div className="mt-10 flex items-center justify-between border-b border-background-200 pb-4">
          <h2 className="font-heading text-lg font-bold text-foreground-950">
            {current ? current.name : "全部内容"}
            <span className="ml-2 text-sm font-normal text-foreground-500">共 {list.length} 篇</span>
          </h2>
          <Link to="/hot" className="text-sm text-primary-600 hover:text-primary-700">
            查看热榜 →
          </Link>
        </div>

        {list.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((a) => (
              <ArticleCard key={a.id} article={a} />
            ))}
          </div>
        ) : (
          <p className="mt-10 rounded-lg border border-dashed border-background-300 p-10 text-center text-sm text-foreground-500">
            该栏目内容正在整理中，先看看其他栏目吧。
          </p>
        )}
      </section>
    </>
  );
}